import { apiClient } from '@/utils/api-client'

/**
 * Environment webhook service for managing environment webhooks.
 */
class EnvironmentWebhookService {
    /**
     * Create a webhook for a project environment.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @param {Object} payload - Webhook payload
     * @returns {Promise<Object>} Create response
     */
    async create(projectKey, environmentKey, payload) {
        return await apiClient
            .post(
                '/projects/' +
                    projectKey +
                    '/environments/' +
                    environmentKey +
                    '/webhooks',
                payload
            )
            .then((response) => {
                return response.data
            })
    }

    /**
     * Remove a webhook by ULID.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @param {string} webhookUlid - Webhook ULID
     * @returns {Promise<Object>} Remove response
     */
    async remove(projectKey, environmentKey, webhookUlid) {
        return await apiClient
            .delete(
                '/projects/' +
                    projectKey +
                    '/environments/' +
                    environmentKey +
                    '/webhooks/' +
                    webhookUlid
            )
            .then((response) => {
                return response.data
            })
    }

    /**
     * List webhooks for a project environment.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @returns {Promise<Object>} Webhooks list response
     */
    async list(projectKey, environmentKey) {
        return await apiClient
            .get(
                '/projects/' +
                    projectKey +
                    '/environments/' +
                    environmentKey +
                    '/webhooks'
            )
            .then((response) => {
                return response.data
            })
    }

    /**
     * Update a webhook.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @param {string} webhookUlid - Webhook ULID
     * @param {Object} payload - Update payload
     * @returns {Promise<Object>} Update response
     */
    async update(projectKey, environmentKey, webhookUlid, payload) {
        return await apiClient
            .put(
                '/projects/' +
                    projectKey +
                    '/environments/' +
                    environmentKey +
                    '/webhooks/' +
                    webhookUlid,
                payload
            )
            .then((response) => {
                return response.data
            })
    }

    /**
     * Get the delivery log for a webhook.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @param {string} webhookUlid - Webhook ULID
     * @returns {Promise<Object>} Deliveries list response
     */
    async deliveries(projectKey, environmentKey, webhookUlid) {
        return await apiClient
            .get(
                '/projects/' +
                    projectKey +
                    '/environments/' +
                    environmentKey +
                    '/webhooks/' +
                    webhookUlid +
                    '/deliveries'
            )
            .then((response) => {
                return response.data
            })
    }
}

export default new EnvironmentWebhookService()
